module.exports = __webpack_public_path__ + "static/media/cabinet-3.7b00d570.webp";